import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function ReceiptCustomization({ children }) {
  useInjectSaga({ key: 'settingsReceiptCustomization', saga });
  useInjectReducer({ key: 'settingsReceiptCustomization', reducer });

  return React.Children.only(children);
}

ReceiptCustomization.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withReceiptCustomization } from './withReceiptCustomization';
export default compose(withConnect, memo)(ReceiptCustomization);
